import React from "react";
import { createBrowserHistory } from "history";
import { Router } from "react-router-dom";

const history = createBrowserHistory();

export const AppProviders: React.FC = ({ children }) => {
  return <Router history={history}>{children}</Router>;
};
